import { render, staticRenderFns } from "./btraextra_new.vue?vue&type=template&id=43240351"
import script from "./btraextra_new.vue?vue&type=script&lang=js"
export * from "./btraextra_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports